import { render } from "./createOrder.vue?vue&type=template&id=31839b69&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"

import "./createOrder.vue?vue&type=style&index=0&id=31839b69&lang=less&scoped=true"
import "./createOrder.vue?vue&type=style&index=1&id=31839b69&lang=less"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31839b69"]])

export default __exports__